var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({attrs:{"color":_vm.color,"href":_vm.href,"target":"_blank","title":_vm.title}},'v-btn',_vm.$attrs,false),[_vm._t("default",function(){return [_c('v-icon',{staticClass:"mr-1"},[_vm._v("\n\t\t\tmdi-facebook\n\t\t")]),_vm._v("\n\t\tFacebook\n\t")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }